const constants = require('@/util/constants')
require('./config')

/**
 * 上传 web push token
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateToken(endpoint, key, auth, successcb, failedcb) {
    axios.post('/api/push/web/update/token', {
        endpoint,
        key,
        auth
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}